import { useContext, useEffect, useState } from "react";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import axios from "axios";
import { BASE_URL, EDIT_CONSULTATION_CHAT, GET_CONSULTATION_CHAT, REFER_PATIENT, UPDATE_CONSULTATION_CHAT } from "../../API";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import card3 from "../../Assets/Images/AIImg.png";
import card2 from "../../Assets/Images/user2.png";
import { GoDotFill } from "react-icons/go";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Flag from "../../Assets/Images/pencil.png";
import { Form } from "react-bootstrap";
import { dateFormatter } from "../../utils/helper";
import { ProfileContext } from "../../context/ProfileContext";
import ToggleSwitch from "../../components/button/ToggleSwitch";
import TextareaAutosize from 'react-textarea-autosize';


function ConsultationView() {
  const { headers, navigate, getConsultation, getRefferal } = useContext(ProfileContext)
  const location = useLocation();
  const { data } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [editedMessages, setEditedMessages] = useState({});
  const [enabled, setEnabled] = useState(data?.diagnostic_data?.is_diagnosticTest ?? false)

  useEffect(() => { getConsultationChat() }, []);

  const getConsultationChat = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_CONSULTATION_CHAT}?id=${data?._id}`, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) { setChatData(json.data) }
      else { console.log("Error fetching products") }
    }
    catch (err) { console.error("Best season product fetch error:", err) }
    finally { setIsLoading(false) }
  };

  const handleMarkAsCompleted = async () => {
    setIsLoading(true)
    const formData = new FormData();
    formData.append("id", data?._id);
    try {
      const response = await axios.post(BASE_URL + UPDATE_CONSULTATION_CHAT, formData, { headers });
      if (response.data.code === 200 && response.data.status === true) {
        getUpdateHistory()
        getConsultation();
        navigate('/dashboard');
      }
    }
    catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
      else { toast.error("An error occurred") }
    }
    finally { setIsLoading(false) }

  };

  const handleFlagClick = (messageId, currentMessage) => {
    setIsEditable(isEditable === messageId ? null : messageId);
    setEditedMessages((prev) => ({
      ...prev,
      [messageId]: currentMessage,
    }));
  };

  const handleEditMessage = async (messageId) => {
    if (editedMessages[messageId] === "") { toast.warn('Please enter the proper note.'); return }
    const formData = new FormData();
    formData.append("messageId", messageId);
    formData.append("newMessage", editedMessages[messageId] || "");

    try {
      const response = await axios.put(BASE_URL + EDIT_CONSULTATION_CHAT, formData, { headers });
      if (response.data.code === 200 && response.data.status === true) {

        setChatData((prev) =>
          prev.map((chat) =>
            chat._id === messageId ? { ...chat, message: editedMessages[messageId] } : chat
          )
        );
        setIsEditable(null); // Exit edit mode
        setEditedMessages((prev) => {
          const updated = { ...prev };
          delete updated[messageId];
          return updated;
        });


      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      } else {
        toast.error("An error occurred");
      }
    } finally {
      // setIsLoading(false)
    }

  };

  const handleMessageChange = (messageId, value) => {
    setEditedMessages((prev) => ({
      ...prev,
      [messageId]: value,
    }))
  };

  // Parse AI response for consultation sections
  const parseAIResponse = (response) => {
    if (!response || !response.response) return null;
    const text = response.response;
    const sections = [];
    let parts = [];
    const spaceParts = text.split('Question :').filter(part => part.trim());
    spaceParts.forEach(part => {
      if (part.includes('Question:')) {
        const subParts = part.split('Question:').filter(subPart => subPart.trim());
        parts.push(...subParts);
      }
      else { parts.push(part); }
    });
    parts.forEach((part, index) => {
      const answerIndex = part.indexOf('Answer:') !== -1 ? part.indexOf('Answer:') : part.indexOf('Answer :');
      if (answerIndex !== -1) {
        const question = part.substring(0, answerIndex).trim();
        const answerStartIndex = part.indexOf('Answer:') !== -1 ? answerIndex + 7 : answerIndex + 8;
        let answer = part.substring(answerStartIndex);
        const nextQuestionIndex = answer.search(/Question\s*:/);
        if (nextQuestionIndex !== -1) {
          answer = answer.substring(0, nextQuestionIndex);
        }
        answer = answer.trim();
        if (question && answer) {
          sections.push({
            question: question,
            answer: answer
          });
        }
      }
    });
    return sections;
  };

  const getUpdateHistory = async () => {
    const payload = { dialogue: chatData, };
    try {
      const response = await axios.post('https://t2tjje1kde.execute-api.us-east-1.amazonaws.com/dev/updatehistory', payload, { headers: { 'Content-Type': 'application/json' }, timeout: 80000, });
      if (response.status === 200) { return response.data }
      return "I'm sorry, I couldn't process your request at the moment.";
    }
    catch (error) {
      if (error.code === 'ECONNABORTED') { return 'Request timed out. The server is taking too long to respond.' }
      return "I'm sorry, there was an error processing your request. Please try again later.";
    }
  };

  const handleReferralToggle = async (_id) => {
    if (enabled) { return }
    const payload = { _id }
    try {
      const response = await axios.post(BASE_URL + REFER_PATIENT, payload, { headers });
      if (response.data.code === 200 && response.data.status === true) {
        setEnabled(true)
        getRefferal();
      }
    }
    catch (error) {
      if (error.response && error.response.data) {
        const errorMessage = error.response.data.error || "An error occurred";
        toast.error(errorMessage);
      }
      else { toast.error("An error occurred") }
    }
  };

  const handleDiscard = async (_id, message) => {
    setIsEditable(false)
    handleMessageChange(_id, message);
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/dashboard" }}>Consultation Logs</Breadcrumb.Item>
                  <Breadcrumb.Item active>View Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex">
                <h6 className="comm_page_heading mb-0">Consultation Details</h6>
              </div>

              <Row className="row-gap-5">
                <Col lg={8}>
                  <h5 className="comm_inner_sub_heading"> Conversation Details </h5>
                  <div className="ai_chat_box_left">
                    <div className="chat-main">
                      <div className="all-chat-main">
                        {chatData && chatData.length > 0 ?
                          chatData.map((item, index) => {
                            return (
                              <div key={item?._id || index}>
                                {item?.sender === 'User' ?
                                  <div className="d-flex flex-column chat_box">
                                    <div className="chat_inn_box second_user_txt-flex">
                                      <div className="img-chat-date d-flex">
                                        <div className="profile-chat-img">
                                          <img src={card2} alt="" className="img-fluid" />
                                        </div>
                                        <div className="chat_box_outer">
                                          <div className="chat-box">
                                            <p className="chat_text second_user_txt">{item?.message}</p>
                                            <span className="cs_chat_time second">{dateFormatter(item?.createdAt)}</span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  :
                                  <div className="d-flex flex-column chat_box">
                                    <div className="chat_inn_box">
                                      <div className="img-chat-date d-flex">
                                        <div className="profile-chat-img">
                                          <img src={card3} alt="" className="img-fluid" />
                                        </div>
                                        <div className="chat_box_outer">
                                          <div className="chat-box">
                                            <Form.Group className="comn-class-inputs">
                                              <TextareaAutosize
                                                minRows={2}
                                                maxRows={40}
                                                value={editedMessages.hasOwnProperty(item._id) ? editedMessages[item._id] : item.message}
                                                onChange={(e) => handleMessageChange(item._id, e.target.value)}
                                                placeholder="Enter Your Notes Here"
                                                disabled={isEditable !== item?._id}
                                                className="chat_text first_user_txt w-100 no-resize"
                                              />
                                            </Form.Group>
                                            <span className="cs_chat_time first">
                                              {data?.is_approved === false ?
                                                <img src={Flag} alt="" className="img-fluid cursor-pointer" onClick={() => handleFlagClick(item?._id, item?.message)} />
                                                :
                                                null
                                              }
                                              {dateFormatter(item?.createdAt)}
                                            </span>
                                          </div>
                                          {isEditable === item?._id && (
                                            <div className="d-flex inner_chat_btn_grp">
                                              <button className="discard_btn" onClick={() => handleDiscard(item._id, item.message)}>Discard Changes</button>
                                              <button className="main-btn chat_inner_btn" onClick={() => handleEditMessage(item._id)} disabled={isLoading}>Save</button>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            )
                          })
                          :
                          <h6>No Conversation Found!!</h6>
                        }
                      </div >
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <h5 className="comm_inner_sub_heading"> Patient Details: </h5>
                  <div className="patient-detail-outer">
                    <div className="patient-anme-view">
                      <h5>patient ID:</h5>
                      <p>#{data?.user_id?.patient_id}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>patient name:</h5>
                      <p>{data?.user_id?.full_name}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>Phone Number:</h5>
                      <p>{data?.user_id?.number}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>Email:</h5>
                      <p>{data?.user_id?.email}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>date of consultation:</h5>
                      <p>{dateFormatter(data?.createdAt)}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>age:</h5>
                      <p>{data?.age}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>Gender:</h5>
                      <p>{data?.gender}</p>
                    </div>
                    <div className="patient-anme-view">
                      <h5>Condition:</h5>
                      <p>{data?.condition || 'Not Specified'}</p>
                    </div>
                    {data?.diagnostic_data &&
                      <div className="patient-anme-view">
                        <h5>Would you refer this patient?</h5>
                        <ToggleSwitch checked={enabled} onChange={() => handleReferralToggle(data._id)} label={enabled ? <p>Yes</p> : <p>No</p>} />
                      </div>
                    }
                    <div className="patient-anme-view">
                      <h5>status:</h5>
                      <div className={`pending-status ${data?.is_approved ? 'completed' : ''}`}>
                        <GoDotFill />{data?.is_approved ? 'Completed' : 'Pending'}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {data?.is_approved === false ? <button className="main-btn chat_bottom_btn" onClick={() => handleMarkAsCompleted()} >marked as complete</button> : null}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConsultationView;
